import { BaseThunk } from 'components/base/base-thunk';
import { ExportTaskService } from '../service';
import { getLocalStorageValue } from 'utils/helpers';
import moment from 'moment';
import { ALl_STATUS, FORMAT_DATETIME } from 'utils/constants';
import { RootState } from 'store';

const exportTaskService = new ExportTaskService();

const exportTaskThunkManager = new BaseThunk<
    TExportTask,
    IRegisterExportRequest,
    IUpdateExportRequest
>(exportTaskService);

export const getAllExportTasksThunk = exportTaskThunkManager.getAll<
    ResponseBase<TExportTask[]>,
    ExportTaskSearch | undefined
>('exportTask/getAll', (params, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const exportTaskState = state.exportTask;
    const paginateMetaData = exportTaskState.paginateMetaData;

    const contract_code = getLocalStorageValue('contract');
    const isValidValue = (value: any) => value !== null && value !== undefined && value !== '';
    const isDateKey = (key: string) => ['planned_date_from', 'planned_date_to'].includes(key);

    const formatDateValue = (value: any) => moment.utc(value).format(FORMAT_DATETIME.YYYYMMDD2);

    const filter = params
        ? Object.entries(params).reduce<ExportTaskSearch>((acc, [key, value]) => {
              if (key === 'status' && value) {
                  acc[key] = [value.toString()];
              } else if (isValidValue(value) || key === 'delete_at') {
                  acc[key as keyof ExportTaskSearch] = isDateKey(key)
                      ? formatDateValue(value)
                      : value;
              }
              return acc;
          }, {})
        : {};

    const hasOtherKeys = Object.keys(filter).some((key) => key !== 'delete_at');
    const hasStatus = 'status' in filter;

    if (hasOtherKeys && !hasStatus) {
        filter.status = ALl_STATUS;
    } else if (!filter.hasOwnProperty('status')) {
        filter.status = ['1'];
    }

    if (
        filter.status &&
        Array.isArray(filter.status) &&
        filter.status.length === 1 &&
        filter.status[0].includes(',')
    ) {
        filter.status = filter.status[0].split(',');
    }

    const sort = `${exportTaskState.sort?.fieldName}:${exportTaskState.sort?.ascending ? 'asc' : 'desc'}`;

    const request: ExportTaskRequest = {
        page: paginateMetaData.page,
        per_page: paginateMetaData.per_page,
        filter: JSON.stringify({
            ...filter,
            contract_code,
        }),
        ...(exportTaskState.sort?.fieldName ? { sort } : {}),
    };

    return request;
});
